"use strict";
import { StatsigClient } from "@statsig/react-bindings";
import { LocalOverrideAdapterWrapper } from "features/gating/LocalOverrideAdapterWrapper";
export { StatsigClient } from "@statsig/react-bindings";
export {
  StatsigContext,
  StatsigProvider,
  Storage,
  useClientAsyncInit,
  useDynamicConfig,
  useExperiment,
  useFeatureGate,
  useGateValue,
  useLayer,
  useStatsigClient,
  useStatsigUser
} from "@statsig/react-bindings";
const statsigApiKey = process.env.NODE_ENV === "test" ? "dummy-test-key" : process.env.REACT_APP_STATSIG_API_KEY ?? process.env.STATSIG_API_KEY ?? "dummy-topaz-key";
let localOverrideAdapter;
export const getOverrideAdapter = () => {
  if (!localOverrideAdapter) {
    localOverrideAdapter = new LocalOverrideAdapterWrapper(statsigApiKey);
  }
  return localOverrideAdapter;
};
let noopStatsigClient;
export const getStatsigClient = () => {
  if (!noopStatsigClient) {
    noopStatsigClient = new StatsigClient(statsigApiKey, {});
  }
  return noopStatsigClient;
};
